/** Created by azhou on 2019/2/14.*/
<!--注册头部进度条-->
<template>
  <div class="d-center pl-5 pr-5">
    <div class="d-center flex-column" @click="changeStep(1,'resBasicInfo')">
      <div class="step-wrap" :class="{'current':pathStep>=1}">1</div>
      <p class="mt-1 h6">{{storeInfo.type === 3 ? '酒店信息' : '基本信息'}}</p>
    </div>
    <div class="d-center-between" v-for="(item,index) in stepArr" :key="index">
      <hr>
      <div class="d-center flex-column" @click="changeStep(index+2,item.path)">
        <div class="step-wrap" :class="{'current':pathStep>=(index+2)}">{{index+2}}</div>
        <p class="mt-1 h6">{{item.name}}</p>
      </div>
    </div>
    <div class="d-center-between">
      <hr class="long-hr">
      <div class="d-center flex-column" @click="changeStep(stepArr.length+2,'regVerify')">
        <div class="step-wrap" :class="{'current':pathStep>=stepArr.length+2}">{{stepArr.length+2}}</div>
        <p class="mt-1 h6">提交认证</p>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex' 

  export default {
    name: 'ProgressBar',
    data () {
      return {
        Step: 1
      }
    },
    computed: {
      ...mapGetters(['storeInfo']),
      pathStep () {
        if (this.$route.name === 'regVerify') return this.stepArr.length + 2;
        return this.$route.query.step;
      },
      stepArr () {
        switch (this.storeInfo.type) {
          case 3:
          case 5:
            return [
              {name:'门店相册',path:'regStorePhotos'},
              {name:'添加房型',path:'regRoomLists'},
              {name:'添加会议室',path:'regMeetLists'},
            ];
          case 6:
          case 8:
            return [
              {name:'门店相册',path:'regStorePhotos'},
            ];
          default:return [];
        }
      }
    },
    methods: {
      changeStep (step,pathName) {
        if (this.storeInfo.verify === 2) return;
        this.$emit('changeStep',step,pathName);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .step-wrap {
    width: 20px;
    height: 20px;
    border: 1px solid #000;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .current {
    border: 1px solid #3395d9;
    background: #3395d9;
    color: #fff;
  }

  hr {
    height: 0.8px;
    background: #3395d9;
    width: 150px;
  }

  .long-hr {
    height: 0.8px;
    background: #3395d9;
    width: 220px;
  }
</style>
